import { Component, Input } from '@angular/core'
import { MbCheckoutBaseFormPartialComponent } from '../mb-checkout-base-form-partial/mb-checkout-base-form-partial.component'

@Component({
  selector: 'mb-checkout-city-form-partial',
  templateUrl: './mb-checkout-city-form-partial.component.html',
})
export class MbCheckoutCityFormPartialComponent extends MbCheckoutBaseFormPartialComponent {

  @Input() cityLabelKey= 'address.city'
}
